import { Box, Typography } from "@mui/material";

interface Props {
	title: string
}

const TitleElement = (props: Props) => {
	return (
		<Box sx={{ minHeight: "20px" }}>
			{props.title && (
				<Box sx={{ minHeight: "20px" }}>
					<Typography variant="body1" sx={{ fontSize: "0.8rem" }}>
						{props.title}
					</Typography>
				</Box>
			)}
		</Box>
	);
};

export default TitleElement;
